// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsWinnerUpdateBody = {
  poolId: string;
  stripWinnerId: string;
  wonAt: string;
  note: string;
};

export type typeStripsWinnerUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { stripWinnerId: string; wonAt: string; note: string };
};

export type typeStripsWinnerUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsWinnerUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsWinnerUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsWinnerUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    stripWinnerId: { type: "string", maxLength: 3000, minLength: 1 },
    wonAt: { type: "string", maxLength: 3000, minLength: 1 },
    note: { type: "string", maxLength: 3000, minLength: 0 },
  },
  required: ["poolId", "stripWinnerId", "wonAt", "note"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsWinnerUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsWinnerUpdateBody);
  }

  return async function postStripsWinnerUpdate(
    payload: typeStripsWinnerUpdateBody,
  ): Promise<
    typeStripsWinnerUpdateOutput200 | typeStripsWinnerUpdateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsWinnerUpdate" failed before calling the network. #4369d34e5566`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4369d34e5566" },
        },
        data: null,
      } as typeStripsWinnerUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/winner-update`,
      httpMethod: "POST",
      options,
    })) as typeStripsWinnerUpdateOutput200 | typeStripsWinnerUpdateOutput400;
  };
}
